import { render } from "./orphanedCourses.vue?vue&type=template&id=f345579a"
const script = {}

import "./orphanedCourses.vue?vue&type=style&index=0&id=f345579a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__